import React from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'


export default class BusinessLicenseInspection extends React.Component {
  resource = '/moen/health/business_license_inspections'
  form_key = 'business_license_inspection'
  defaults = {}

  // Delete lines as needed
  fee = 99
  free = true
  postpaid = true
  skip_location = true
  hide_buttons = false
  custom_actions = []

  validate = null

  foremost = null

  fields = form => [
    "::Applicant Information",
    {   
        name: "address",
        label: "Home Address",
        hint: "eg. Centerville, Collins Avenue, #5",
    },
    {
        name: "phone_contact",
        label: "Phone #",
        type: "phone",
        required: false,
    },
    {
        name: "po_box",
        label: "P.O. Box",
        required: false,
    },

    "::Business Information",
    {
        name: "business_name",
        label: "Name of Business",
    },
    {
        name: "business_purpose",
        label: "Purpose/Type of Business",
        type: "textarea"
    },
    {
        name: "business_address",
        label: 'Address of Business',
        hint: "eg. Centerville, Collins Avenue, #5",
    },
    {
        name: "business_phone",
        label: "Phone #",
        type: "phone"
    },
    {
        name: "business_fax",
        label: "Fax #",
        type: "phone",
        required: false,
    },
    {
        name: "business_po_box",
        label: "P.O. Box",
        required: false,
    },
    {
        name: "owners_list",
        label: "Names of Business Owners/Managers (if applicable)",
        hint: "List all owners and managers of the business.",
        required: false,
        fields: [
            {
                name: 'first_name',
                label: 'First Name',
                required: false,
            },
            {
                name: 'middle_name',
                label: 'Middle Name',
                required: false
            },
            {
                name: 'last_name',
                label: 'Last Name',
                required: false,
            },
            {
                name: 'position',
                label: 'Position',
                options: [
                    { label: "Owner", value: "owner" },
                    { label: "Manager", value: "manager" },
                ],
                required: false,
            }
        ]
    },
    {
        name: "new_business",
        label: "Is this a new business?",
        type: 'select:bool',
    },
    {
        name: "select_all",
        label: "Select all that apply",
        type: "checklist",
        options: [
            {label: "FLOOR PLAN", value: "floor plan"},
            {label: "GARBAGE CERTIFICATE", value: "garbage certificate"},
            {label: "STAFF HEALTH MEDICAL CERTIFICATES", value: "health certificates"},
            {label: "PEST CONTROL CONTRACT", value: "pest control contract"},
            {label: "THE WATER AND SEWAGE CORPORATION FORM", value: "water and sewage form"},
        ],
        multi: true
    },
    {
        name: "fees_amount",
        label: "D.E.H.S. Facilities Amount",
        type: "currency"
    },
    {
        name: "vehicle_amount",
        type: "currency"
    }


  ]

  render = () => <Wizard {...SERVICE_PROPS(this)} />
}
